import MultilangInput from '@/components/common/multilanginput/MultilangInput.vue'

export default {
  name: 'TranslationsList',
  data () {
    return {
      loading: true,
      currentReq: null,
      tableItems: [],
      filters: {
        code: '',
        value: ''
      },
      paging: { limit: 20, page: 1, total: 0, pages: 0 },
      isMounted: false
    }
  },
  components: {
    MultilangInput
  },
  computed: {
    canEdit () {
      return this.ApiRequest.userHasPermission('edit-settings');
    }
  },
  methods: {
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    getTableData () {
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.loading = true;
      this.$forceUpdate();
      const self = this;
      const path = 'translations/list?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      this.currentReq = this.ApiRequest.request(path, this.ApiRequest.REQUEST_POST, this.BasicHelper.cloneObject(this.filters), function (response) {
        if (response.data) {
          self.tableItems = response.data;
          self.paging = response.paging;
          self.loading = false;
        }
      });
    },
    cancelEdit (item) {
      item.tooltip = item.originalValue.tooltip;
      item.editing = false;
      this.$forceUpdate();
    },
    editItem (item) {
      item.originalValue = this.BasicHelper.cloneObject(item);
      if (item.tooltip === null) {
        item.tooltip = {};
      }
      item.editing = true;
      this.$forceUpdate();
    },
    saveItem (item) {
      item.loading = true;
      item.editing = false;
      item.originalValue = null;
      this.$forceUpdate();
      const reqData = this.BasicHelper.cloneObject(item);
      const self = this;
      this.ApiRequest.request('translations/edit', this.ApiRequest.REQUEST_POST, reqData, function (response) {
        if (response.error) {
          self.ApiRequest.displayErrorDialog(response, self);
        }
        item.loading = false;
      })
    },
    updateFilters () {
      this.paging.page = 1;
      this.getTableData();
    }
  },
  mounted () {
    this.getTableData();
    this.isMounted = true;
  }
}
